import React, { useContext, useEffect, useState } from 'react';
import { VesselDwtTypesContext } from '../TcIndexPage';
import BasicSelector from '../Basic/BasicSelector';

function _VesselType({ 
    vesselType, 
    countIndex, 
    changeFieldsMultiple, 
    required = false, 
    setHasErrors, 
    labelStyle = {},
    disabled = false,
    currentTypeGeneral,
}) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);
    const [dataList, setDataList] = useState(vesselDwtTypes);
    
    const selectVesselType = (_id) => {
        const toChange = [
            {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: vesselDwtTypes.find(t => t._id === _id),
            },
        ];

        if (_id !== vesselType._id) {
            toChange.push(
                {
                    index: countIndex,
                    field: 'vesselId',
                    value: null,
                },
                {
                    index: countIndex,
                    field: 'vessel.imoNumber',
                    value: '',
                },
            );
        }

        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true);
            } else {
                setHasErrors('vesselDwtGroup', false);
            }
        }
    }, [vesselType]);

    useEffect(() => {
        if (currentTypeGeneral) {
            setDataList(vesselDwtTypes.filter(d => d.typeByPurpose.includes(currentTypeGeneral)));
        }
    }, [currentTypeGeneral]);

    return (
        <BasicSelector 
            value={vesselType && vesselType._id}
            dataList={dataList}
            onChange={(e, _i, value) => selectVesselType(value)}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            labelStyle={{ padding: 0, top: 'unset', ...labelStyle }}
            fields={['name']}
            disabled={
                disabled ||
                !dataList.length || !dataList.some(d => d.name)
            }
        />
    );
}

export default React.memo(_VesselType);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/VesselType.jsx